import { Stack } from "@mui/material";
import { GenericTimeline } from "../GenericTimeline";
import { QuestionnaireResponseView } from "./QuestionnaireResponseView";

interface QuestionnaireHistoryViewProps {
  responses: any[];
  questionnaire: any;
  isMobile?: boolean;
}

export function QuestionnaireHistoryView({
  responses,
  questionnaire,
  isMobile = false,
}: QuestionnaireHistoryViewProps) {
  const timelineData = responses.map((response) => {
    return {
      awnserDate: response.resource.authored,
      resource: response.resource,
      status: response.resource.status,
    };
  });

  return (
    <Stack>
      <GenericTimeline
        data={timelineData}
        component={(data: any, index: number) => (
          <QuestionnaireResponseView
            data={data}
            index={index}
            questionnaire={questionnaire}
            isMobile={isMobile}
          />
        )}
      />
    </Stack>
  );
}
